import { WidthContainer } from '@pata-app/ui-document';
import { SponsoredPlacement, useSponsoredPlacement } from '@pata-app/ui-sponsored-placements';

import React, { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useGetBusinesses } from '../../../../hooks/useGetBusinessSearch';
import {
  BusinessCarouselContainer,
  BusinessTilesSectionContainer,
  SectionTitle,
  BusinessTilesContainer,
  BusinessAdPlaceholder,
} from './businessCarousel.styled';
import { BusinessTile } from './components/businessTile';

if (typeof window !== 'undefined') {
  import('react-loading-skeleton/dist/skeleton.css');
}

function BusinessCarousel() {
  const { data: businessData, isLoading: businessDataLoading } = useGetBusinesses();

  const sponsoredPlacement = useSponsoredPlacement('home.list.sponsored_tile');

  const petbusinessData = useMemo(
    () => businessData?.sort((a, b) => (a.bookingType === 'online' && b.bookingType !== 'online' ? -1 : 1)),
    [businessData],
  );
  // const petTrainerBusinesses = useMemo(
  //   () => trainingData?.sort((a, b) => (a.bookingType === 'online' && b.bookingType !== 'online' ? -1 : 1)),
  //   [trainingData],
  // );

  return (
    <BusinessCarouselContainer id="newsletter">
      <WidthContainer>
        <BusinessTilesSectionContainer>
          <SectionTitle>
            <h2>
              Popular pet care services <span>near you</span>
            </h2>
            <p>Browse trusted local groomers, sitters, dog trainers, dog walkers, vets, and more – all in one place</p>
          </SectionTitle>
          <BusinessTilesContainer>
            {Boolean(petbusinessData?.length) && (
              <>
                {petbusinessData?.map((business, index) => (
                  <React.Fragment key={business.id}>
                    <BusinessTile index={index} business={business} />
                    {index === 0 && Boolean(sponsoredPlacement) && (
                      <BusinessAdPlaceholder>
                        <SponsoredPlacement placementKey="home.list.sponsored_tile" />
                      </BusinessAdPlaceholder>
                    )}
                  </React.Fragment>
                ))}
              </>
            )}
            {!petbusinessData?.length && !businessDataLoading && <div />}
          </BusinessTilesContainer>

          {businessDataLoading && (
            <div>
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
            </div>
          )}
        </BusinessTilesSectionContainer>
        {/* <BusinessTilesContainer>
          <h2>
            Pet trainers <span>near you</span>
          </h2>
          {Boolean(petTrainerBusinesses?.length) && (
            <div>
              {petTrainerBusinesses?.map((business, index) => (
                <BusinessTile key={business.id} index={index} business={business} />
              ))}
            </div>
          )}
          {trainingLoading && (
            <div>
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
              <Skeleton height={'285px'} count={1} />
            </div>
          )}
        </BusinessTilesContainer> */}
      </WidthContainer>
    </BusinessCarouselContainer>
  );
}

export default BusinessCarousel;
